import React, { Component } from 'react';
import { Grid, Row, Col, Button } from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';

import Form from 'react-jsonschema-form';
import SweetAlert from 'react-bootstrap-sweetalert';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as CategoriesActions from './redux/CategoriesActions';

// import SelectRemoteWidget from "@softwareland/react/build/components/widgets/widget-selectRemote.js"
import SelectRemoteWidget from '../../lib/widget-selectRemote';
import UploadField from '../../lib/field-upload';

const schema = {
    definitions: {},
    $schema: 'http://json-schema.org/draft-07/schema#',
    $id: 'http://example.com/root.json',
    type: 'object',
    // title: 'The Root Schema',
    required: ['name', 'slug', 'subcategories'],
    properties: {
        name: {
            $id: '#/properties/name',
            type: 'string',
            title: 'Nombre',
            default: '',
            examples: ['Tailor-Made'],
            pattern: '^(.*)$'
        },
        slug: {
            $id: '#/properties/slug',
            type: 'string',
            title: 'Slug',
            default: '',
            examples: ['tailormade'],
            pattern: '^(.*)$'
        },
        video: {
            $id: '/properties/video',
            type: 'array',
            title: 'Video',
            default: ''
        },
        videoLink: {
            $id: '#/properties/videoLink',
            type: 'string',
            title: 'Link del Video',
            default: ''
        },
        logo: {
            $id: '/properties/logo',
            type: 'array',
            title: 'Logo',
            default: ''
        },
        image: {
            $id: '/properties/image',
            type: 'array',
            title: 'Imagen',
            default: ''
        },

        subcategories: {
            $id: '#/properties/subcategories',
            type: 'array',
            title: 'Subcategorías',
            items: {
                $id: '#/properties/subcategories/items',
                type: 'object',
                title: 'Sub',
                required: ['name', 'slug', 'image'],
                properties: {
                    name: {
                        $id: '#/properties/subcategories/items/properties/name',
                        type: 'string',
                        title: 'Nombre',
                        default: '',
                        examples: ['Campaña'],
                        pattern: '^(.*)$'
                    },
                    slug: {
                        $id: '#/properties/subcategories/items/properties/slug',
                        type: 'string',
                        title: 'Slug',
                        default: '',
                        examples: ['campana'],
                        pattern: '^(.*)$'
                    },
                    image: {
                        $id:
                            '#/properties/subcategories/items/properties/image',
                        type: 'string',
                        title: 'Imagen'
                    }
                }
            }
        }
    }
};

const widgets = {
    SelectRemoteWidget: SelectRemoteWidget
    // SelectWidget: SelectWidget
};

const fields = {
    UploadField: UploadField
    // SelectWidget: SelectWidget
};

const uiSchema = {
    image: {
        'ui:field': 'UploadField'
    },
    logo: {
        'ui:field': 'UploadField'
    },
    video: {
        'ui:field': 'UploadField'
    },
    subcategories: {
        items: {
            image: {
                'ui:field': 'UploadField'
            }
        }
    }
};

const log = type => console.log.bind(console, type);

class CategoriesForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.match.params.id,
            openConfirm: false,
            openSuccess: false
        };

        console.log('Props', props.match.params);
    }

    componentWillMount() {
        if (this.state.id !== 'create') this.props.findById(this.state.id);
    }

    onSubmit = ({ formData }) => {
        let _this = this;
        console.log('Data submitted: ', formData);
        if (
            formData.password === '' ||
            formData.password === undefined ||
            formData.password == null
        )
            delete formData.password;

        if (this.state.id !== 'create') {
            this.props.update(formData.id, formData).then(function() {
                _this.props.history.push('/admin/categories');
            });
        } else {
            this.props.create(formData).then(function() {
                _this.props.history.push('/admin/categories');
            });
        }
    };

    onDelete(confirm = false) {
        let _this = this;
        if (confirm) {
            this.props.remove(this.state.id).then(function() {
                _this.props.history.push('/admin/categories');
            });
        } else {
            this.setState({ openConfirm: true });
        }
    }

    onBlur = (id, value) => {
        console.log('Data submitted: ', this.state.formData);
    };

    render() {
        let { history, Categories } = this.props;
        let { id, openConfirm, openSuccess } = this.state;
        console.log('Categories', Categories);
        return (
            <div className="main-content">
                {openConfirm && (
                    <SweetAlert
                        warning
                        style={{ display: 'block', marginTop: '-100px' }}
                        title="¿Estás Seguro?"
                        onConfirm={() => this.onDelete(true)}
                        onCancel={() => this.setState({ openConfirm: false })}
                        confirmBtnBsStyle="info"
                        cancelBtnBsStyle="danger"
                        confirmBtnText="Si, borrar!"
                        cancelBtnText="Cancelar"
                        showCancel
                    >
                        No podrás desaser está opción!
                    </SweetAlert>
                )}

                {openSuccess && (
                    <SweetAlert
                        success
                        style={{ display: 'block', marginTop: '-100px' }}
                        title="Listo!"
                        confirmBtnBsStyle="info"
                        onConfirm={() => this.setState({ openSuccess: false })}
                    >
                        Se ha actualizado correctamente!
                    </SweetAlert>
                )}

                <Grid fluid>
                    <Row>
                        <Col md={12}>
                            <Card
                                title={<legend>Editar Categoría</legend>}
                                content={
                                    <div>
                                        <Form
                                            schema={schema}
                                            widgets={widgets}
                                            fields={fields}
                                            uiSchema={uiSchema}
                                            onSubmit={this.onSubmit}
                                            onBlur={this.onBlur}
                                            formData={Categories.formData}
                                            onError={log('errors')}
                                        >
                                            <div>
                                                <Button
                                                    bsStyle="success"
                                                    type="submit"
                                                    className="btn-fill"
                                                >
                                                    Guardar
                                                </Button>{' '}
                                                <Button
                                                    bsStyle="default"
                                                    onClick={() =>
                                                        history.push(
                                                            '/admin/categories'
                                                        )
                                                    }
                                                >
                                                    Cancelar
                                                </Button>
                                                <div className="pull-right">
                                                    {id !== 'create' ? (
                                                        <Button
                                                            bsStyle="danger"
                                                            onClick={() =>
                                                                this.onDelete(
                                                                    false
                                                                )
                                                            }
                                                        >
                                                            Borrar
                                                        </Button>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </Form>

                                        <div className="clearfix" />
                                    </div>
                                }
                            />
                        </Col>
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        Categories: state.Categories
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(CategoriesActions, dispatch);
};

const CategoriesConnect = connect(
    mapStateToProps,
    mapDispatchToProps
)(CategoriesForm);

export default CategoriesConnect;



// WEBPACK FOOTER //
// ./src/views/Categories/CategoriesForm.jsx